<script lang="ts">
    import bybit from './bybit.svg'

    let screenWidth = window.innerWidth
    let logoWidth = screenWidth >= 992 ? 357 : 200

    window.addEventListener('resize', () => {
        screenWidth = window.innerWidth
    })

    let count = Math.floor(screenWidth / (logoWidth + (screenWidth >= 992 ? 100 : 50)))
    // let animationSpeed = count / 5
</script>

<div class="line-wrapper">
    <a href="https://www.bybit.com/uk-UA/trade/spot/lis/usdt" target="_blank" class="line" style="animation-duration: {count}s">
        {#each Array.from({ length: count }) as _, i}
            <img src="{bybit}" alt="bybit">
        {/each}
    </a>
</div>

<style>
    @keyframes line {
        0% {
            transform: translateX(0%);
        }
        100% {
            transform: translateX(100vw);
        }
    }

    .line-wrapper {
        overflow: hidden;
        width: 100%;
        margin-top: 35px;
    }

    .line {
        display: flex;
        justify-content: space-around;
        /*animation: line 6s linear infinite;*/
        /*margin-left: -400vw;*/
        /*width: 500vw;*/
    }

    .line img {
        width: 357px;
        margin: 0 50px;
    }

    @media(max-width: 991px) {
        .line img {
            width: 200px;
            margin: 0 25px;
        }
    }
</style>
